import { COLOR_ISO_639_CODE_BY_LOCALE } from "@color/lib";
import { useQuery } from "@tanstack/react-query";
//#region src/Translation/TranslatedMessages.ts
/**
* Establish a standardized interface for loading translation messages. This provides
* minimal structure and preserves flexibility for variations in loading strategy,
* e.g:
* - load files locally
* - load files from remote source like Cloudfront
* - callers use feature flags to determine loading
*/
var TranslatedMessages = class {
	options;
	constructor(props) {
		this.options = props;
	}
	async getMessages(locale) {
		if (locale === this.options.defaultLocale) return this.options.defaultMessages;
		if (locale in COLOR_ISO_639_CODE_BY_LOCALE) {
			const translationFileName = COLOR_ISO_639_CODE_BY_LOCALE[locale];
			return this.options.loadTranslatedMessages(translationFileName);
		}
		throw new Error(`Unknown locale: ${locale}`);
	}
};
//#endregion
//#region src/Translation/useRemoteMessagesQuery.ts
/**
* Assumes API Request clients are provided by react-query's QueryClientProvider queryFn.
*/
var useRemoteMessagesQuery = (props, options) => {
	const { contentSourceUrl, projectId, locale } = props;
	const formattedUrl = `${contentSourceUrl}/${projectId}/${COLOR_ISO_639_CODE_BY_LOCALE[locale]}.json`;
	return useQuery({
		queryKey: [formattedUrl],
		...options
	});
};
//#endregion
//#region src/Translation/constants.ts
var LokaliseProjectNames = {
	Home: "home",
	AoU: "aou",
	Common: "common"
};
//#endregion
export { useRemoteMessagesQuery as n, TranslatedMessages as r, LokaliseProjectNames as t };

//# sourceMappingURL=Translation-DNhy27J-.js.map